module.exports = __webpack_public_path__ + "img/landingpage_campaign01-fase02-02proteccionhogar.94c319cd.jpg";